import React from 'react';
import { Link } from 'react-router-dom';
import CompanyCard from './CompanyCard';
import { CompanyCardHeader } from '@rd-web-markets/market/dist/company';
const CompanyListForDocuments = _ref => {
  let {
    companies,
    accountType
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "company-cards-container"
  }, companies.map(company => {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CompanyCard, {
      key: company.id,
      model: company,
      accountType: accountType,
      refreshCompanies: () => {},
      CompanyCardHeader: CompanyCardHeader,
      to: `/${accountType}/documents?key=documents&model_type=Company&model_id=${company.id}&model_name=${company.name}`,
      type: "company"
    }));
  }));
};
export default CompanyListForDocuments;